import script from "./EstadisticasView.vue?vue&type=script&setup=true&lang=js"
export * from "./EstadisticasView.vue?vue&type=script&setup=true&lang=js"

import "./EstadisticasView.vue?vue&type=style&index=0&id=c8443fde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8443fde"]])

export default __exports__